define([
    'text!product-detail/furniture/design-info-new.html',
    'product-detail/mixin/product',

    'css!product-detail/furniture/design-info-new.css'
], function(
    tpl,
    ProductMixin
){
    return {
        template: tpl,
        mixins: [ProductMixin],
        computed: {
            designText: function(){
                return this.spuExtraBase.designText || '';
            },
            iconClass: function(){
                return 'u-icon-'+ this.spuBase.categoryClass;
            },
            designerData: function(){
                return this.spuExtraBase.designerData || {};
            },
            isPC: function () {
                if($(window).width()<=750){
                    $('.fixed-menu').css({display: 'none'});
                    return false;
                }else {
                    return true;
                }
            }
        },
        mounted: function () {
            var obj = this;
            $(window).resize( function  () {           //当浏览器大小变化时
                if(($(window).width()<=750&&obj.isPC)||($(window).width()>750&&!obj.isPC)){
                    window.location.reload();
                }
            });
        }
    };
});


//////////////////
// WEBPACK FOOTER
// ./product-detail/furniture/design-info-new.js
// module id = 318
// module chunks = 0